<template>
  <div style="margin-left:80px">
    <b-row>
      <b-col cols="12" v-if="onboarding">
        <h5 class>Приглашем Вас начать обучение!</h5>
        <b-button
          @click="next"
          variant="primary"
          style="margin: 10px 0; color:white; padding:10px 30px;"
        >Перейти к симулятору</b-button>
      </b-col>
      <b-col cols="12" v-else>
        <h5 v-if="!fun">Вы завершили прохождение главы. Для продолжения оцените её:</h5>
        <h5 v-else>Поздравляем! Вы завершили эту страницу!</h5>
        <p class="mb-2 mt-4">Полезность страницы</p>
        <star-rating
          class="mb-4"
          v-model="useful"
          :show-rating="false"
          :star-size="40"
          :read-only="utility?true:false"
          active-color="#08a2dc"
        ></star-rating>
        <p class="mb-2">Интересность страницы</p>
        <star-rating
          v-model="interest"
          :star-size="40"
          :read-only="fun?true:false"
          :show-rating="false"
          active-color="#08a2dc"
          class="mb-3"
        ></star-rating>
        <b-button
          v-if="!fun"
          @click="next"
          variant="primary"
          style="margin: 10px 0; color:white; padding:10px 30px;"
          :disabled="proccess"
        ><b-spinner small  v-if="proccess" style="margin-right:5px;"></b-spinner>Завершить</b-button>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import StarRating from "vue-star-rating";
import API from "@/api";


export default {
  name: "End",
  props: {
    page: Number,
    onboarding: Boolean,
    fun: Number,
    utility: Number
  },
  components: {
    StarRating
  },
  data: function() {
    return {
      useful: this.utility?this.utility:0,
      interest: this.fun?this.fun:0,
      disabled: false, 
      proccess: false
    };
  },
  watch: {
    data: function (val) {
      this.proccess = false
    },
  },
  methods: {
    go() {
      this.$emit("end");

    },
    next() {
    
      if (this.onboarding || (this.useful && this.interest)) {
        this.proccess = true
        if (this.onboarding) {
          this.$emit("end");
        } else {
          const config = {
            headers: { Authorization: `Bearer ${this.$store.state.token}` }
          };
          const data = new FormData();
          data.append("utility", this.useful);
          data.append("fun", this.interest);
          data.append("page", this.page);
          API.post("api/score_page/", data, config).then(
            response => {
      
              if(response.data.end)
              {
                
                this.$store.commit("setPage", { page: 0, onboarding: true });
                const config = {
                  headers: { Authorization: `Bearer ${this.$store.state.token}` }
                };
                const data = new FormData();
                data.append("page", 0);
                API.post("api/set_current_page/", data, config).then(response => {
                  this.$router.push('/certificate')
                })
                
              }
              else{
                this.$emit("end");
              }
              
            }
          );

        }
      } else {
        this.$bvToast.toast("Это обязательно", {
          title: "Нужно оценить страницу",
          autoHideDelay: 5000
        });
      }
    }
  }
};
</script>


<style>
.mb-3.disabled {
  cursor: not-allowed;
}
</style>